<div class="badge-container">
  <rt-icon *ngIf="iconName && !iconTmpl" size="small-xx" [name]="iconName"></rt-icon>
  <ng-container
    *ngIf="iconTmpl && !iconName"
    [ngTemplateOutlet]="iconTmpl"
    [ngTemplateOutletContext]="iconTmplContext"
  ></ng-container>
  <span>{{ text }}</span>
</div>
